import React, { Fragment } from 'react';
import styled from 'styled-components';
import ArrowIcon from '../assets/icons/chevron_right.png';

// Breadcrumb Component
const BreadcrumbComponent = ({ items }) => {
  return (
    <BreadcrumbContainer>
      {items.map((item, index) => (
        <Fragment key={index}>
          <BreadcrumbTitle className="breadcrumb-item">{item}</BreadcrumbTitle>
          {index < items.length - 1 && <ArrowImg src={ArrowIcon} alt="arrow right" />}
        </Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

export default BreadcrumbComponent;

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #777;
  padding: 0 120px;
  margin-bottom: 70px;

  .breadcrumb-item {
    color: #555;
    font-weight: 500;
    margin-right: 10px;

    &:last-child {
      color: #333;
    }
  }

  .separator {
    margin-right: 10px;
    color: #ccc;
  }

  @media (max-width: 480px) {
    padding: 0 20px;
    margin-bottom: 35px;
  }
`;

const BreadcrumbTitle = styled.span`
  font-size: 16px;
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const ArrowImg = styled.img`
  width: 30px;
  height: 30px;

  @media (max-width: 480px) {
    width: 20px;
    height: 20px;
  }
`;
